import { format, toDate } from "date-fns";

const formatDate = (
  dateString: string | null | undefined,
  smallMonth = false
) => {
  if (!dateString) return null;
  try {
    return format(
      toDate(dateString),
      smallMonth ? "dd MMM yyyy" : "dd MMMM yyyy"
    );
  } catch {
    return null;
  }
};

export const getSalespersonContractPeriod = (
  contractStartDate: string | null | undefined,
  contractEndDate: string | null | undefined,
  smallMonth = false
) => {
  if (!contractStartDate) {
    return "No End Date";
  }

  const start = formatDate(contractStartDate, smallMonth);
  const end = formatDate(contractEndDate, smallMonth) ?? "No End Date";

  return `${start} - ${end}`;
};
